import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthLayout } from "@/components/AuthLayout";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { GoogleButton, OrDivider } from "@/components/GoogleButton";

export default function Login() {
  const { applyAuth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      applyAuth(data);
      toast.success(`Welcome back, ${data.user.name.split(" ")[0]}`);
      navigate(location.state?.from || (data.user.role === "superadmin" ? "/admin" : "/dashboard"));
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout testId="login-page" title="Welcome back" subtitle="Log in to continue to your geoportal."
      footer={<span>New here? <Link to="/register" data-testid="login-register-link" className="text-emerald-800 dark:text-emerald-400 font-semibold">Create an account</Link></span>}>
      <GoogleButton testId="login-google-button" />
      <div className="my-5"><OrDivider /></div>
      <form onSubmit={submit} className="space-y-5">
        <div className="space-y-2"><Label htmlFor="email">Email</Label><Input id="email" type="email" data-testid="login-email-input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required className="h-11 rounded-xl" /></div>
        <div className="space-y-2">
          <div className="flex justify-between items-center"><Label htmlFor="password">Password</Label><Link to="/forgot-password" data-testid="login-forgot-link" className="text-xs text-emerald-800 dark:text-emerald-400 font-medium">Forgot password?</Link></div>
          <Input id="password" type="password" data-testid="login-password-input" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required className="h-11 rounded-xl" />
        </div>
        {error && <p data-testid="login-error" className="text-sm text-red-600 bg-red-50 dark:bg-red-950/40 border border-red-200 dark:border-red-900 rounded-lg px-3 py-2">{error}</p>}
        <Button data-testid="login-submit-button" type="submit" disabled={loading} className="w-full h-11 rounded-full bg-emerald-900 hover:bg-emerald-800 dark:bg-emerald-500 dark:text-slate-950 font-semibold">{loading ? "Logging in…" : "Log in"}</Button>
      </form>
    </AuthLayout>
  );
}
